import { ExperimentOutlined } from '@ant-design/icons';

import { shouldShowTestEnvironmentBadge } from '@helpers/isTestApiEnvironment';

import './testEnvironmentBadge.scss';

/**
 * Небольшая метка «TEST» при API_URL на test.apelsin.smart-laboratory.ru (см. .env).
 */
const TestEnvironmentBadge = (): JSX.Element | null => {
    if (!shouldShowTestEnvironmentBadge()) {
        return null;
    }

    return (
        <div
            className="test-environment-badge"
            title="Подключение к тестовому API"
            aria-hidden
        >
            <ExperimentOutlined className="test-environment-badge__icon" />
            <span className="test-environment-badge__text">TEST</span>
        </div>
    );
};

export { TestEnvironmentBadge };
